<template>
   <div class="end-stream" v-if="streamEnded">
      <div class="container px-5">
         <p class="end-stream__content">
            ライブ配信が終了しました。
            <br />ご視聴とコメント、ありがとうございました。
         </p>
         <a href="/" class="btn btn-crimson custom-btn">イベントページに戻る</a>
      </div>
   </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
   name: "EndStreamScreen",
   props: {},
   data: () => ({}),
   computed: {
      ...mapGetters(["streamEnded"])
   },
   methods: {
      ...mapActions(["updateStreamEnded"])
   },
   beforeDestroy() {
      if (this.streamEnded) this.updateStreamEnded(false);
   }
};
</script>

<style lang="scss" scoped>
.end-stream {
   color: $color-white;
   font-size: 1.8rem;
   z-index: 1000;
   position: absolute;
   top: 0;
   left: 0;
   background-color: $color-black;
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;

   &__content {
      text-align: center;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0.05em;
      margin-bottom: 6rem;
   }
}
</style>
